// extracted by mini-css-extract-plugin
export default {"btn":"HorizontalButtons_btn__z4wvv","selected":"HorizontalButtons_selected__a-5l9"};